import { motion } from "framer-motion";

export const ParallelNarratives = () => {
  return (
    <div className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="font-serif text-4xl text-center mb-16 text-story-germany">Two Hearts, One Journey</h2>
        
        <div className="grid md:grid-cols-2 gap-8">
          {/* Tachen's Story */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-white p-8 rounded-lg shadow-lg"
          >
            <h3 className="font-serif text-2xl mb-4 text-story-sudan">Tachen's Journey: From Darkness to Light</h3>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Born in the shadows of uncertainty in a refugee camp, my early life was marked by more than just physical disability. 
                Each day was a battle against not just my condition, but the crushing weight of feeling different, abandoned, and lost 
                in a world that seemed too big, too harsh.
              </p>
              <p>
                The whispers and stares followed me everywhere - a constant reminder of my limitations. But deep within, a flame of 
                hope refused to die. When German aid workers discovered me, it wasn't just medical treatment they offered - it was 
                a chance at a new life, a chance to believe in myself again.
              </p>
              <p>
                Through countless surgeries and rehabilitation sessions, I learned that my true strength wasn't in my legs, but in 
                my heart. Each step forward, no matter how small, became a victory against the doubts that had plagued me. The 
                journey wasn't just about learning to walk - it was about learning to trust, to hope, and to believe in the 
                possibility of miracles.
              </p>
            </div>
          </motion.div>

          {/* Bettina's Story */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-white p-8 rounded-lg shadow-lg"
          >
            <h3 className="font-serif text-2xl mb-4 text-story-germany">Bettina's Heart: A Call to Love</h3>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                When I first started at Friedensdorf, I thought I was prepared for anything. But nothing could have prepared me 
                for Tachen - a young boy whose spirit shone brighter than any star, despite the darkness that surrounded him. 
                In those early days, I wasn't just a social worker; I became a witness to pure resilience.
              </p>
              <p>
                Our car rides to medical appointments became sacred moments of connection. Through his pain, through his fears, 
                I watched him fight. His laughter, even in the hardest moments, taught me more about courage than any training 
                ever could. In his eyes, I saw not just suffering, but an unwavering determination to live, to thrive, to become 
                more than his circumstances.
              </p>
              <p>
                For 26 years, I carried his memory like a precious stone in my heart. Every child I helped afterward carried a 
                piece of what Tachen taught me - that love transcends borders, that hope has no language, and that sometimes, 
                the greatest act of healing is simply being there, holding space for another's pain and dreams. When social 
                media finally brought us back together, it wasn't just a reunion - it was proof that some bonds are truly timeless.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};